import { LandingPageSection } from './types'

export function getSectionURL(
  mountPath: string,
  landingPageSection: LandingPageSection,
): string {
  return `${mountPath === '/' ? '' : mountPath}${landingPageSection.path}`
}
